import { useEffect, useState } from "react";

export function useIntersectionObserver(ref, options) {
    const [isIntersecting, setIntersecting] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;

        const observer = new IntersectionObserver(([entry]) => {
            setIntersecting(entry.isIntersecting);
        }, options);

        observer.observe(node);

        return () => {
            observer.disconnect();
        };
    }, [ref, options]);

    return isIntersecting;
}